import { useTranslation } from "react-i18next";
import { ActionsType } from "@/components/custom/data-table/buttons/data-table-actions";
import {
  PiTagChevron,
  PiCubeFocus,
  PiUpload,
  PiClock,
  PiFolders,
  PiMapPin,
} from "react-icons/pi";
import {
  DeployModelAction,
  ServiceDeploymentAction,
  TagsActions,
  UploadConfigAction,
  OperationalHoursAction,
  UploadCatalogAction,
  SiteGroupAction,
  RegionsActions,
} from "./-sites-actions-components";
import { SitesTableContext } from "./-sites-table-context";
import { usePermissions } from "@/hooks/use-permissions";

export const useActions = (): ActionsType => {
  const { t } = useTranslation();
  const { permissions } = usePermissions();
  const isAllSelected = SitesTableContext.useTable().getAllSelected();
  return [
    {
      label: t("deployModel"),
      title: t("deployModelToSites"),
      actionContent: DeployModelAction,
      icon: PiCubeFocus,
      dialogClassName: "!w-[1000px] !max-w-[90vw]",
      disabled: false,
    },
    // ID-7057 phase 2: bulk region assignment by id. Gated like the route (PATCH /sites/regions
    // is sites.edit); the pre-freeze entry had no gate at all.
    permissions.sites.edit && {
      label: t("updateRegion"),
      title: t("updateRegions"),
      actionContent: RegionsActions,
      icon: PiMapPin,
    },
    permissions.siteGroups.assignSites && {
      label: t("updateSiteGroup"),
      title: t("updateSiteGroup"),
      actionContent: SiteGroupAction,
      icon: PiFolders,
    },
    {
      label: t("deployComponent"),
      title: t("deployComponentToSites"),
      actionContent: ServiceDeploymentAction,
      icon: PiCubeFocus,
    },
    // Gated like the route (PATCH /sites/tagsBulk is sites.tags.update, which Owner and SiteManager lack -- ID-7148).
    permissions.sites.tags.update && {
      label: t("tag"),
      title: t("editTags"),
      actionContent: TagsActions,
      icon: PiTagChevron,
      disabled: isAllSelected,
    },
    {
      label: t("uploadConfig"),
      title: t("uploadConfigToSites"),
      actionContent: UploadConfigAction,
      icon: PiUpload,
    },
    {
      label: t("uploadCatalog"),
      title: t("uploadCatalog"),
      actionContent: UploadCatalogAction,
      icon: PiUpload,
    },
    {
      label: t("operationalHours"),
      title: t("updateOperationalHours"),
      actionContent: OperationalHoursAction,
      icon: PiClock,
    },
  ].filter(Boolean) as ActionsType;
};
